module.exports = __webpack_public_path__ + "static/icon_biezhen1eb2bc76070c4ffad8a5a955dc5af463.png";